import { request } from "./core";

export interface EndUserGrantSummary {
    token_id: string;
    provider_id: string;
    provider_name: string;
    provider_display_name: string;
    scopes_granted: string | null;
    granted_at: string;
    last_used_at: string | null;
    expires_at: string | null;
}

export interface EndUserGrantsResponse {
    server_id: string;
    server_display_name: string;
    end_user_id: string;
    grants: EndUserGrantSummary[];
}

export interface GrantsUrlParams {
    server_id: string;
    end_user_id: string;
    exp: string;
    sig: string;
}

function grantsQs(p: GrantsUrlParams): string {
    return new URLSearchParams({
        server_id: p.server_id,
        end_user_id: p.end_user_id,
        exp: p.exp,
        sig: p.sig,
    }).toString();
}

export function listEndUserGrants(
    p: GrantsUrlParams,
): Promise<EndUserGrantsResponse> {
    return request(`/end-user-grants?${grantsQs(p)}`, { anonymous: true });
}

export function revokeEndUserGrant(
    token_id: string,
    p: GrantsUrlParams,
): Promise<void> {
    return request(
        `/end-user-grants/${encodeURIComponent(token_id)}?${grantsQs(p)}`,
        { method: "DELETE", anonymous: true },
    );
}
